<ng-container *ngIf="display$ | async as vm">
  <!-- The comparison request is in flight. hs-loader is deliberately not used here — its host
       sits at opacity: 0 until an `active` class is added on top of `[loading]`, so `[loading]`
       alone renders an invisible overlay (see workbench-grid.component.html for the same note). -->
  <div
    *ngIf="vm.loading"
    class="comparison-loading"
    data-cy="comparison-loading"
    role="status"
    aria-live="polite"
  >
    <span class="spinner-border" aria-hidden="true"></span>
    <span class="comparison-loading-label">Loading…</span>
  </div>

  <!-- No manual load yet, or the typed id had no match: the shared empty-state card. -->
  <hs-panel-card
    *ngIf="vm.emptyState as emptyState"
    [header]="emptyState.header"
  >
    <p>{{ emptyState.body }}</p>
  </hs-panel-card>

  <!-- The comparison request failed (e.g. the backend is not yet deployed). -->
  <hs-panel-card *ngIf="vm.error" header="Comparison Unavailable">
    <p>
      The position comparison could not be loaded. Please try again once a
      position is reselected.
    </p>
  </hs-panel-card>

  <!-- A single anchor is selected and its comparison has loaded. -->
  <div class="position-comparison" *ngIf="vm.comparison as comparison">
    <div class="comparison-toolbar">
      <div class="comparison-toolbar__sources">
        <span class="comparison-toolbar__label">Sources</span>
        <label
          *ngFor="let source of comparison.sources; trackBy: trackBySource"
          class="comparison-toolbar__source-toggle"
        >
          <input
            type="checkbox"
            [checked]="!isSourceHidden(source.source)"
            [disabled]="source.source === comparison.anchor"
            (change)="toggleSource(comparison, source.source)"
          />
          {{ source.source }}
        </label>
      </div>

      <label class="comparison-toolbar__checkbox" *ngIf="vm.isMultiSource">
        <input
          type="checkbox"
          [checked]="vm.differencesOnly"
          (change)="onDifferencesOnlyChange($event)"
        />
        Differences Only
      </label>

      <label class="comparison-toolbar__checkbox" *ngIf="vm.isMultiSource">
        <input
          type="checkbox"
          [checked]="vm.comparisonsOnly"
          (change)="onComparisonsOnlyChange($event)"
        />
        Comparisons Only
      </label>

      <select
        *ngIf="vm.isMultiSource && vm.differenceKeys.length > 1"
        class="comparison-toolbar__difference-key"
        [ngModel]="vm.differenceKey"
        (ngModelChange)="onDifferenceKeyChange($event)"
      >
        <option *ngFor="let key of vm.differenceKeys" [value]="key">
          {{ comparison.anchor }} − {{ key }}
        </option>
      </select>

      <input
        type="text"
        class="comparison-toolbar__search"
        placeholder="Search Table..."
        [value]="vm.search"
        (input)="onSearchChange($event)"
      />
    </div>

    <nf-table-layout
      [hideTitle]="true"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="rows$ | async"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>

    <div class="comparison-footer">
      <span>Fields: {{ vm.fieldsCount }}</span>
    </div>
  </div>
</ng-container>
